import { render, staticRenderFns } from "./CustomVueExcelXlsx.vue?vue&type=template&id=eee96dcc"
import script from "./CustomVueExcelXlsx.vue?vue&type=script&lang=js"
export * from "./CustomVueExcelXlsx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports